// externals
import React from 'react';

// components
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';
import { Button } from '@interstate/components/Button';

// styles
import { StyledFooter } from './SoftPullConsentModal.styles';

export interface SoftPullConsentModalProps {
    show?: boolean;
    onCancel: () => void;
    onAccept: () => void;
}

const MODAL_BODY =
    "Continue to initiate a soft credit pull. This will obtain the customer's credit information solely for evaluating " +
    'financing and deal structure options, which will be presented through AI-powered personalized insights. ' +
    "This inquiry will not affect the customer's credit score. If you cancel, the soft pull link will appear under the Lender's tab.";

const SoftPullConsentModal: React.FC<SoftPullConsentModalProps> = ({ show, onCancel, onAccept }) => {
    const prefix = 'soft-pull-consent-modal';

    const footer = (
        <StyledFooter>
            <Button data-testid={`${prefix}-cancel-button`} buttonStyle="tertiary" onClick={onCancel}>
                Cancel
            </Button>
            <Button id={`${prefix}-accept-button`} data-testid={`${prefix}-accept-button`} buttonStyle="primary" onClick={onAccept}>
                I Accept
            </Button>
        </StyledFooter>
    );

    return (
        <Modal
            data-testid={prefix}
            show={!!show}
            footer={{
                footerComponent: footer
            }}
            onHide={onCancel}
            size="large"
            sx={{
                // Hide the close (X) button - user must explicitly click Cancel or Accept
                '#ids-modal-close-button': {
                    display: 'none'
                },
                // Disable backdrop click to close - user must explicitly click Cancel or Accept
                '& .MuiBackdrop-root': {
                    pointerEvents: 'none'
                },
                '& .MuiDialog-container': {
                    pointerEvents: 'none'
                },
                '& .MuiDialog-paper': {
                    pointerEvents: 'auto'
                }
            }}
        >
            <Typography data-testid={`${prefix}-body`} variant="body-md" color="base.color.gray.600" tag="div">
                {MODAL_BODY}
            </Typography>
        </Modal>
    );
};

export default SoftPullConsentModal;
